module.exports = __webpack_public_path__ + "static/img/kff.90bcb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/kff.png
// module id = PVIs
// module chunks = 0